$(function () {

    $('.main_visual').imagesLoaded( function() {
        // 画像を読み込んだ後に実行したい処理
        $(this).delay(500).queue(function(){
            $('body').addClass("start");
        });
    });

});